import { FC, ReactElement, HTMLAttributes } from "react";
import { use100vh } from "react-div-100vh";
import styled from "styled-components";

interface ScreenContainerProps {
  HeaderComponent: ReactElement<any, any>;
  FooterComponent?: ReactElement<any, any>;
}

interface ContainerProps {
  height: string;
  hasFooterComponent: boolean;
}

const Container = styled.div<ContainerProps>`
  min-height: ${({ height }) => height};
  max-width: 71.25rem;
  margin: 0 auto;
  padding-top: 6.25rem;

  @media ${({ theme }) => theme.device.desktop} {
    padding: 6.25rem 1rem 0 1rem;
  }

  @media ${({ theme }) => theme.device.mobile} {
    min-height: ${({ height }) => height};
    padding-top: 3.5rem;
    padding-bottom: ${({ hasFooterComponent }) =>
      hasFooterComponent ? 4.5 : 0}rem;
  }
`;

const ScreenContainer: FC<
  ScreenContainerProps & HTMLAttributes<HTMLDivElement>
> = ({ HeaderComponent, FooterComponent, ...props }) => {
  const height = use100vh();

  const containerHeight = height ? `${height}px` : "100vh";

  const hasFooterComponent = !!FooterComponent;

  return (
    <>
      {HeaderComponent}
      <Container
        height={containerHeight}
        hasFooterComponent={hasFooterComponent}
        {...props}
      />
      {hasFooterComponent && FooterComponent}
    </>
  );
};

export default ScreenContainer;
